import { ComponentType, SVGProps } from 'react';
import { ReactComponent as USFlag } from 'assets/img/icons/US.svg';
import { ReactComponent as CAFlag } from 'assets/img/icons/CA.svg';

export type CountryFlagComponent = ComponentType<SVGProps<SVGSVGElement>>;

const COUNTRY_FLAGS: Record<string, CountryFlagComponent> = {
  US: USFlag,
  CA: CAFlag,
};

// Inline SVG components (not <img src>) so flags still render when the PDF is generated server-side.
export const getCountryFlag = (country: string): CountryFlagComponent | undefined =>
  COUNTRY_FLAGS[country.trim().toUpperCase()];
